/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import type { AxisScale } from '@visx/axis';
import { GlyphCircle } from '@visx/glyph';
import type { GlyphCircleProps } from '@visx/glyph/lib/glyphs/GlyphCircle';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { Collection, type ContextValue, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface CircleGlyphsProps
  extends Omit<GlyphCircleProps<{ x: number; y: number }>, 'children' | 'className' | 'left' | 'size' | 'top'> {
  data?: { x: number; y: number }[];
  xScale?: AxisScale;
  yScale?: AxisScale;
  innerWidth?: number;
  innerHeight?: number;
  color?: string;
  strokeWidth?: number;
  size?: number;
  style?: stylex.StyleXStyles;
}

const CircleGlyphsContext = createContext<ContextValue<CircleGlyphsProps, SVGGElement>>({});

const CircleGlyphs = forwardRef((props: CircleGlyphsProps, ref: ForwardedRef<SVGGElement>) => {
  [props, ref] = useContextProps(props, ref, CircleGlyphsContext);

  const { style, data = [], xScale, yScale, innerWidth, innerHeight, color, strokeWidth = 1, size = 6 } = props;

  return (
    <g ref={ref} {...stylex.props(styles.base, style)}>
      <Collection items={data} dependencies={[innerWidth, innerHeight]}>
        {(item) => {
          const left = xScale!(item.x);
          const top = yScale!(item.y);

          if (left == null || top == null) {
            return null;
          }

          return (
            <GlyphCircle
              id={`${item.x}-${item.y}`}
              left={Number(left)}
              top={Number(top)}
              size={size}
              {...stylex.props(glyphStyles.base(color!, strokeWidth))}
            />
          );
        }}
      </Collection>
    </g>
  );
});

const styles = stylex.create({
  base: {
    pointerEvents: 'none',
  },
});

const glyphStyles = stylex.create({
  base: (color: string, strokeWidth: number) => ({
    fill: $.surfaceBGPrimary,
    stroke: color,
    strokeWidth: strokeWidth,
  }),
});

export { CircleGlyphs, CircleGlyphsContext, type CircleGlyphsProps };
